import React, { createContext, useContext, useState } from 'react'

import AwsS3 from '@uppy/aws-s3'
import Uppy from '@uppy/core'
import config from '../config'

const UppyContext = createContext()

// eslint-disable-next-line react/prop-types
export const UppyProvider = ({ children }) => {
  const [uppy] = useState(() =>
    new Uppy().use(AwsS3, {
      getChunkSize: () => 8 * 1024 * 1024,
      shouldUseMultipart: true,
      endpoint: config.companionUrl
    })
  )

  return <UppyContext.Provider value={uppy}>{children}</UppyContext.Provider>
}

export const useUppy = () => {
  return useContext(UppyContext)
}
